import { ApiProperty } from "@nestjs/swagger";
import { FgInspectionSamplesDTO} from "./fg-inspection-samples.dto";
export class FgInspectionDTO{    
    
    @ApiProperty()
    fgInspectionId: number;

    @ApiProperty()
    date:Date

    @ApiProperty()
    section:string

    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    saleOrderItemId: number;

    @ApiProperty()
    lotNumber:string

  
    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    samplesInfo : FgInspectionSamplesDTO[]
}